<template>
  <input
    v-if="isMasked"
    v-bind="$attrs"
    :readonly="readonly"
    :name="name"
    :id="id || uniqueId"
    v-model="modelValue"
    v-maska
    :data-maska="mask"
    :value="optValue"
    :placeholder="placeholder"
    :class="[inputStateClass, errorFeedbackClass]"
    class="sword-base-input-wuk"
    :disabled="disabled"
    v-on="listeners"
    @focus="setAsFocus"
    @blur="removeAsFocus($event)"
  />
  <input
    v-else
    v-bind="$attrs"
    :readonly="readonly"
    :name="name"
    :id="id || uniqueId"
    v-model="modelValue"
    :value="optValue"
    :placeholder="placeholder"
    :class="[inputStateClass, errorFeedbackClass]"
    class="sword-base-input-wuk"
    :disabled="disabled"
    v-on="listeners"
    @focus="setAsFocus"
    @blur="removeAsFocus($event)"
  />
</template>

<script>
import { vMaska } from 'maska';
import inputHandler from '@ui-kit/mixins/inputHandler';
import inputValidationTriggers from '@ui-kit/mixins/inputValidationTriggers';
import validationClasses from '@ui-kit/mixins/inputValidationClasses';

export default {
  name: 'BaseInput',
  mixins: [inputHandler, inputValidationTriggers, validationClasses],
  directives: {
    maska: vMaska,
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      required: true,
    },
    name: {
      type: String,
      default: null,
    },
    id: {
      /**
       * Define if you want a specific id (i.e. for labels of checkbox and radio buttons)
       */
      type: String,
      required: false,
    },
    optValue: {
      /**
       * Define for checkbox and radio button usage
       */
      type: [String, Number, Boolean],
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    mask: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    listeners() {
      const {
        input, tabindex, focus, blur, ...listeners
      } = this.$listeners;
      return listeners;
    },
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isMasked() {
      const acceptableTypes = ['text', 'tel', 'password', 'search', 'url', 'email'];
      return (
        this.mask
        && (typeof this.$attrs.type === 'undefined' || acceptableTypes.includes(this.$attrs.type))
      );
    },
  },
};
</script>

<style lang="scss">
input {
  background: $input-background-color-wuk;
}
</style>
